import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/app/node_modules/@interness/web-core/src/templates/mdx/default.js";
import { graphql } from 'gatsby';
import { FaCalendarAlt } from "react-icons/fa";
import LiveEvents from '@interness/web-core/src/components/modules/Events/Events';
import CallToAction from '@interness/theme-sonora/src/components/CallToAction/CallToAction';
export const query = graphql`
  query {
    headerImages: directusMediaCollection(name: {eq: "events-header"}) {
      name
      images: media {
        file {
          localFile {
            name
            childImageSharp {
              fluid(maxWidth: 1400, cropFocus: CENTER) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`;
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const HeaderImage = makeShortcode("HeaderImage");
const Img = makeShortcode("Img");
const Heading = makeShortcode("Heading");
const Wrapper = makeShortcode("Wrapper");
const layoutProps = {
  query,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




<HeaderImage mdxType="HeaderImage">
    <Img fluid={props.data.headerImages.images[0].file.localFile.childImageSharp.fluid} alt='Events' mdxType="Img" />
</HeaderImage>
<hr></hr>
<Heading icon={<FaCalendarAlt mdxType="FaCalendarAlt" />} mdxType="Heading">Events & Aktuelles</Heading>
<Wrapper mdxType="Wrapper">
Regelmäßig bieten wir Ihnen Neuigkeiten und Veranstaltungen rund um die Themen Schmuck und Uhren. Erfahren Sie viel Wissenswertes, und werden Sie in unseren Kursen selbst kreativ.
<hr></hr>
  <LiveEvents mdxType="LiveEvents" />
<hr></hr>
<p>{`Wir freuen uns auf Sie!`}</p>
</Wrapper>
<hr></hr>
<CallToAction mdxType="CallToAction" />


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      